import md5 from "js-md5";

export function getRandomColor(key) {
  const hex = md5.hex(key);
  return `#${hex.slice(0, 6)}`;
}
